// src/components/EmailVerificationBanner.jsx
// Rendered by ProtectedRoute whenever a real firm exists but
// firm.email_verified_at is still null (signup was interrupted before the
// code step completed — see kailux-master-plan.md item 16). Deliberately a
// dismissible-feeling, non-blocking banner rather than a hard redirect:
// email verification only actually blocks AI-cost/generation actions
// server-side (_require_account_verified), not general navigation, so this
// shouldn't either — same "explore while pending" philosophy as
// PracticeVerificationPending.
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Mail } from 'lucide-react'

import { T } from '../theme/theme'
export default function EmailVerificationBanner() {
  const { firm } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  if (!firm || firm.email_verified_at) return null
  if (location.pathname === '/verify-email') return null

  return (
    <div style={{
      position: 'fixed', top: 16, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9998, background: T.s2, border: `1px solid ${T.or}`,
      borderRadius: '10px', padding: '12px 18px', display: 'flex',
      alignItems: 'center', gap: '14px', boxShadow: T.shl,
      fontFamily: "'Outfit',sans-serif", maxWidth: '92vw',
    }}>
      <Mail size={16} color={T.or} style={{ flexShrink: 0 }} />
      <span style={{ color: T.tx, fontSize: '13px' }}>
        Please verify your email to unlock AI features.
      </span>
      <button onClick={() => navigate('/verify-email')} style={{
        padding: '6px 14px', borderRadius: '7px', border: 'none',
        background: T.prg, color: T.onpri,
        fontWeight: 700, fontSize: '13px', cursor: 'pointer', flexShrink: 0,
      }}>
        Verify now
      </button>
    </div>
  )
}
